// A game's ending result: how the ending started for the reader, and how the
// game ended. The stage grid (`stage-result.ts`) with the game's outcome as
// the end, so every game that reached an ending falls in exactly one result:
//
//   start \ outcome   win        draw       loss
//   winning           won        blown      blown
//   level             won        drawn      lost
//   lost              comeback   comeback   lost
//
// Pure: the caller (api-insights' fact extractor) supplies the score.
import type { EndingResult, EndingStart, GameOutcome } from '@chess/api-model';
import { stageCellOf, standingOf, standingOfOutcome, type StageCell } from './stage-result.ts';

/** How the ending started for the reader, from their score in pawns; undefined without a score. */
export function endingStartOf(pawns: number | undefined, winningPawns: number): EndingStart | undefined {
  return standingOf(pawns, winningPawns);
}

const NAME: Record<StageCell, EndingResult> = { up: 'won', comeback: 'comeback', even: 'drawn', blown: 'blown', down: 'lost' };

/** The ending result of a game that started its ending at `start` and ended in `outcome`. */
export function endingResultOf(start: EndingStart, outcome: GameOutcome): EndingResult {
  return NAME[stageCellOf(start, standingOfOutcome(outcome))];
}
